import styled from 'styled-components';
import { MAIN_COLOR } from '../../../components/globalThemes';

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    background-color: white;
    max-width: 400px;
    height: 250px;
    width: 95%;
    border: 1px solid black;
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    margin: 30px;
`;

export const StyledFormRow = styled.div`
    display: flex;
    flex-direction: column;
    margin: 30px;
`;

export const StyledLabel = styled.label`
    font-family: BlenderProBold, serif;
    letter-spacing: 1px;
    font-size: 16px;
    color: black;
`;

export const StyledInput = styled.input`
    font-family: Roboto Condensed, serif;
    width: 100%;
    height: 25px;
    border: 0;
    border: 1px solid #dcdcdc;
    border-radius: 5px;
    background-color: #dcdcdc;
    z-index: 1;
    outline: none;

    &:hover {
        border: 1px solid #bab8b8;
    }

    &:focus {
        border: 1px solid ${MAIN_COLOR};
        background-color: white;
    }
`;

export const InputWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 25px;
    margin-top: 10px;
`;

export const ConfirmButton = styled.button`
    width: 100px;
    height: 30px;
    align-self: center;
    z-index: 1;
    background-color: transparent;
    border: 0;
    border: 2px solid orange;
    border-radius: 5px;
    font-family: BlenderProBold, serif;
    font-size: 12px;
    cursor: pointer;
    transition: all 3s ease-in-out;

    &:hover {
        background-color: orange;
        border: 2px solid black;
    }
`;

export const LoginInfo = styled.p`
    font-family: Roboto Condensed, serif;
    font-size: 13px;
    font-weight: 300;
    text-align: center;
    display: inline;
    white-space: pre-wrap;
`;

export const LoginInfoBold = styled.p`
    font-family: Roboto Condensed, serif;
    font-size: 13px;
    font-weight: bold;
    display: inline;
`;

export const ErrorInfo = styled.p`
    font-family: Roboto Condensed, serif;
    font-size: 13px;
    color: red;
    text-align: center;
`;
